import PropTypes from 'prop-types';
import classNames from 'classnames';
import React from 'react';
import bindAll from 'lodash.bindall';
import ReactTooltip from 'react-tooltip';
// import isEmpty from "lodash/isEmpty";
import { connect } from 'react-redux';
import VM from 'scratch-vm';

import Divider from '../divider/divider.jsx';
import Button from '../button/button.jsx';

import styles from './aixiong-serialport.css';

import helpIcon from '../../lib/assets/icon--help.svg';

import connectIcon from './connect.png';
import disconnectIcon from './disconnect.png';
// import upload from './upload.png';
import _upload from './_upload.svg';
import upload from './upload.svg';
import duigou from './duigou.png';
import waiting from './waiting.svg';
import ok from './ok.svg';
import reconnect from './reconnect.svg';

import xhr from 'xhr';

class AixiongSerialport extends React.Component {

    constructor(props) {
        //console.log('props ', props)
        super(props);
        bindAll(this, [
            'onClickConnectionMenu',
            'onClickPort',
            'addListeners',
            'removeListeners',
            'handleMouseup',
            'handleDownloadClient',
            'handleExtensionAdded',
        ]);
        this.state = {
            isShowMenuList: false,
            showTrans: false,
            isHandpy: false
        };
    }

    componentDidMount() {
        // if (this.props.open) this.addListeners(); // TODO 优化条件判断
        this.addListeners();
        this.getProfile()
        this.props.vm.addListener('EXTENSION_ADDED', this.handleExtensionAdded);
    }
    // TODO 优化条件判断
    // componentDidUpdate (prevProps) {
    //     if (this.props.open && !prevProps.open) this.addListeners();
    //     if (!this.props.open && prevProps.open) this.removeListeners();
    // }
    handleExtensionAdded() {
        let blockInfo = this.props.vm.runtime._blockInfo
        let isHandpy = false
        for (let i = 0; i < blockInfo.length; i++) {
            const el = blockInfo[i];
            if (el.id == 'handpy') {
                isHandpy = true
                break
            }
        }
        this.setState({ isHandpy })
    }
    componentWillUnmount() {
        this.removeListeners();
    }
    addListeners() {
        document.addEventListener('mouseup', this.handleMouseup);
    }
    removeListeners() {
        document.removeEventListener('mouseup', this.handleMouseup);
    }
    handleMouseup(e) {
        if (!this.connectionStatusMenuRef || !this.connectionStatusMenuRef.contains(e.target)) {
            this.setState({
                isShowMenuList: false
            });
        }
    }

    handleDownloadClient() {
        console.log('download client');
        let isWin = (navigator.platform == "Win32") || (navigator.platform == "Windows");
        let platform = isWin ? 'win' : 'mac'; // 只要不是windows平台就下载mac平台的客户端
        let baseUrl = `https://zhuoshiweilai.oss-cn-hangzhou.aliyuncs.com/scratch/aibear/${platform}/`;
        // let baseUrl = `https://scratchdownloadtest.oss-cn-beijing.aliyuncs.com/${platform}/`;
        let downloadUrl = null;
        fetch(baseUrl + 'package.json')
            .then(response => response.json())
            .then(result => {
                console.log('result', result);
                downloadUrl = baseUrl + result.name + '.' + result.version + '.zip' + `?v=${Date.now()}`;
                console.log('download url', downloadUrl);
                // 下载客户端
                let downloadLink = document.createElement('a');
                downloadLink.href = downloadUrl;
                downloadLink.download = result.name + '.' + result.version;
                downloadLink.setAttribute("target", "_blank");
                downloadLink.style.display = 'none';
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
            });
    }

    onClickConnectionMenu() {
        console.log('ConnectionMenu clicked')
        this.setState({
            isShowMenuList: !this.state.isShowMenuList
        });
    }
    onClickPort(i, port) {
        console.log('port is clicked', i, port);
        this.props.handleConnecting(i, port);
        this.setState({
            isShowMenuList: !this.state.isShowMenuList,
        });
    }
    // upload
    // waiting
    // ok
    getProfile() {
        let domain = location._query['domain'] ? location._query['domain'] : 'https://teacher.e-ai-edu.com'
        let accessToken = location._query['accessToken']
        if (!accessToken) {
            return this.setState({
                showTrans: false
            })
        }
        xhr({
            method: 'get',
            uri: `${domain}/api/users/getProfile?access_token=${accessToken}`,
            headers: {
                "Content-Type": "application/json"
            }
        }, (err, resp, body) => {
            if (err) {
                return this.setState({
                    showTrans: false
                })
            }
            const { data } = JSON.parse(body)
            console.log('user_data', data)
            if (data && data.school && data.school.aibearStatus != 2) {
                this.setState({
                    showTrans: true
                })
            }
            if (data.role[0] == 9 || data.role[0] == 10) {
                if (data && data.classes && data.classes[0]) {
                    // 需要判断
                    if (data.classes[0].periodIndex != 1) {
                        this.props.showCompetition(false)
                    } else {
                        this.props.showCompetition(true)
                    }

                } else {
                    this.props.showCompetition(false)
                }

            } else {
                this.props.showCompetition(true)
            }
            this.props.vm.runtime.ioDevices.Aixiong.userInfor = data;
            sessionStorage.setItem("userInfor", JSON.stringify(data));
        })
    }

    render() {
        // console.log('status', this.props.isSocketConnected, this.props.serialportList.length, this.props.connectedPort);

        const {
            isSocketConnected, serialportList, connectedPort, selectedPortIndex,
            runMode, btnStatus, btnStr
        } = this.props
        const { showTrans, isHandpy } = this.state
        let btnType = upload
        // let btnStr = '连接硬件'
        switch (btnStatus) {
            case 1:
                btnType = upload
                // btnStr = '连接硬件'
                break;
            case 2:
                btnType = waiting
                // btnStr = '正在连接'
                break;
            case 3:
                btnType = ok
                // btnStr = '连接成功'
                break;
            case 4:
                btnType = reconnect
            // btnStr = '端口阻塞, 点击刷新adaptor'
            default:
                btnType = upload
                // btnStr = '连接硬件'
                break;
        }
        const isConnected = (isSocketConnected && connectedPort && serialportList.length > 0) ? true : false

        // console.log('(isConnected || (btnStatus == 4)) --> ', (isConnected || (btnStatus == 4)))
        // showTrans
        // console.log('runMode showTrans --> ', runMode, showTrans)

        return (
            (runMode == 1 && !showTrans)
                ?
                // <div>您所在学校的爱熊编程模块，不支持交互模式</div>
                <div></div>
                :
                <div ref={e => { this.connectionStatusMenuRef = e }} className={styles.dropdown}>
                    <div>
                        {<div style={{ display: 'flex', alignItems: 'center' }}>
                            <div className={styles.dropbtn} onClick={this.onClickConnectionMenu}>
                                <img src={isConnected ? connectIcon : disconnectIcon} />
                                <div>&nbsp;&nbsp;&nbsp;硬件连接&nbsp;</div>
                            </div>
                            {(isConnected || (btnStatus == 4)) &&
                                <div onClick={this.props.handleUploadCode}>
                                    {
                                        (runMode == 1)
                                            ?
                                            isHandpy
                                                ?
                                                <div className={styles.upload}>
                                                    <img style={{ width: '20px' }} src={ok} />
                                                    <div>&nbsp;&nbsp;通信连接</div>
                                                </div>
                                                :
                                                <div className={styles.upload}>
                                                    <img style={{ width: '20px' }} src={btnType} />
                                                    <div>&nbsp;&nbsp;{btnStr}</div>
                                                </div>
                                            :
                                            (btnStatus == 4)
                                                ?
                                                <div className={styles.upload}>
                                                    <img style={{ width: '20px' }} src={btnType} />
                                                    <div>&nbsp;&nbsp;{btnStr}</div>
                                                </div>
                                                :
                                                <div className={styles.upload}>
                                                    <img style={{ width: '20px' }} src={_upload} />
                                                    <div>&nbsp;&nbsp;上传代码</div>
                                                </div>
                                    }

                                </div>}
                            {/* (isConnected || (btnStatus == 4)) &&  */}
                            {((isConnected || (btnStatus == 4)) && isHandpy) &&
                                (<div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Divider className={classNames(styles.divider)} />
                                    <div
                                        className={styles.dropbtn}
                                        onClick={this.props.handleRestoreFirmware}
                                    >
                                        <span style={{ verticalAlign: 'middle', marginRight: '3px' }}>恢复固件</span>
                                        <img
                                            style={{ verticalAlign: 'middle' }}
                                            data-for={'handleRestoreFirmware'}
                                            data-tip={'如果恢复失败，请尝试<br>再次点击恢复固件<br>并按住A键3秒'}
                                            src={helpIcon}
                                        />
                                        <ReactTooltip
                                            effect={'solid'}
                                            multiline
                                            id={'handleRestoreFirmware'}
                                            place={'right'}
                                        />
                                    </div>
                                </div>)
                            }
                        </div>}
                    </div>
                    {this.state.isShowMenuList ? (
                        <div className={styles.dropdownContent} >
                            <div>
                                {!isSocketConnected && <a href="#" style={{ borderBottom: '1px dashed hsla(0, 0%, 0%, 0.15)' }}>Adapter 未连接</a>}
                            </div>
                            <div>
                                {!serialportList.length && <a href="#" style={{ borderBottom: '1px dashed hsla(0, 0%, 0%, 0.15)' }}>硬件未连接</a>}
                            </div>
                            <div>
                                {serialportList && serialportList.map((port, i) => { // 在选择的端口前加对勾
                                    return (
                                        <a href="#" key={i} onClick={() => this.onClickPort(i, port)}>
                                            {selectedPortIndex == i ? <img src={duigou} style={{ marginRight: '8px' }} /> : ""}{port.path} {(port.manufacturer.indexOf('wch') != -1 || port.manufacturer.indexOf('Silicon') != -1) ? port.manufacturer : ''}
                                        </a>
                                    )
                                })}
                            </div>
                            <div onClick={this.props.handleReload} style={{ borderTop: '1px dashed hsla(0, 0%, 0%, 0.15)' }}>
                                <a href="#">刷新 Aibear Adapter</a>
                            </div>
                            {/* <div onClick={this.props.handleRelaunch}>
                            <a href="#">重启 AiBear Adapter</a>
                        </div> */}
                            <div onClick={this.handleDownloadClient}>
                                <a href="#">Aibear Adapter 下载</a>
                            </div>
                        </div>
                    ) : (
                        <div></div>
                    )}

                </div>
        );
    }

};
AixiongSerialport.propTypes = {
    // containerRef: PropTypes.func,
    // dragOver: PropTypes.bool
    vm: PropTypes.instanceOf(VM).isRequired
};

const mapStateToProps = state => ({
    // extensionId: state.scratchGui.connectionModal.extensionId
    // runMode: state.scratchGui.mode.runMode
    vm: state.scratchGui.vm
});

// const mapDispatchToProps = dispatch => ({
//     // onCancel: () => {
//     //     dispatch(()=>{});
//     // }
// });

// export default AixiongSerialport;
export default connect(mapStateToProps)(AixiongSerialport);